<!-- @format -->
<hmf-snackbar
	#snackbar
	class="app-snackbar"
	[position]="'top'"
	[offset]="offset()"
	[type]="'light'"
	[action]="'close'"
	[style.z-index]="zIndex()">
	<div class="snackbar-message hmf-body-bold-l">{{ snackbarService.message() }}</div>
</hmf-snackbar>
